import React from 'react';

const AboutMe = () => {
  return (
    <section id="about" className="my-16 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md transition-colors duration-300">
      {/* Small Section Header */}
      <h2 className="text-xl font-semibold text-gray-400 dark:text-gray-500 mb-6 uppercase tracking-wider">About Me</h2>
      
      <div className="flex flex-col md:flex-row items-center md:items-start gap-8">
        
        {/* Left Side: Image Placeholder */}
        <div className="flex-shrink-0">
          <div className="w-56 h-56 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center border-4 border-blue-500 shadow-xl overflow-hidden">
            
            {/* Remove this span and uncomment the img tag below when you have your picture */}
            <span className="text-gray-500 dark:text-gray-400 font-medium text-center">
              
            </span>
            
            { <img 
              src="https://blogger.googleusercontent.com/img/a/AVvXsEjps867_kXvdf2PJn1xwANtb8bKanB9NQj1P3FfPVfCoB3VDLZ2PYYMf8Tfsyhi8Pz6zIXf14dTkjCrwtwiKnKIesMHL2zVwxcawXSLB-5B9y_ctk2eSdUjTJJSUwh_hfl-dIrjLo3PMvOU3N3WODm89RnRWfvYYsmWSj1qWk9Z95L7dcAvID0IT6LJ54M=w467-h467" 
              alt="Profile" 
              className="w-full h-full object-cover" 
            /> 
            }

          </div>
        </div>

        {/* Right Side: Big Heading Name & Bio */}
        <div className="flex flex-col justify-center text-center md:text-left mt-2">
          {/* Your Name (Big Heading) */}
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white mb-2">
            Richmond Efefante
          </h1>
          
          {/* Subtitle */}
          <h3 className="text-xl font-medium text-blue-600 dark:text-blue-400 mb-4">
            IT - NETSEC Student
          </h3>
          
          {/* Bio Paragraph */}
          <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed max-w-2xl">
            I am an IT student based in Baguio City, passionate about bridging the gap between hardware, software, and data. Whether I'm troubleshooting PC hardware limits, optimizing network configurations, or learning the intricacies of component-based web frameworks like React, I love solving complex problems. When I'm not coding, you can usually find me keeping up with international Valorant esports tournaments.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AboutMe;